module.exports = __webpack_public_path__ + "static/img/a4.6dbfe05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a4.png
// module id = PEHH
// module chunks = 1